import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { EditPermissions } from '../../../../../../../shared/models';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { getEditTypes } from '../../../delegatorUtils';
import { required } from '../../../../../../../shared/utils';

export interface RemapValues {
  key: string,
  value: string
}

export interface RemapFrom {
  name: string,
  description: string,
  remapValues: RemapValues[],
  valueToRemap: string,
  yes: string,
  no: string
}


export const NODE_TYPE = 'remap';

export class Remap {

  action: any = {};

  constructor() {
    this.action = {
      'actionType': NODE_TYPE,
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): FormGroup {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData: RemapFrom = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): RemapFrom {
    const action = stepData?.action ? stepData?.action : {};
    const actionParams = action?.actionParams ? action?.actionParams : {};
    const result = action?.result ? action?.result : {};

    return {
      name: action.name ? action.name : '',
      description: action.description ? action.description : '',
      valueToRemap: actionParams.valueToRemap ? actionParams.valueToRemap : '',
      remapValues: this.remapValues(actionParams.remapValues),
      yes: result.yes ? result.yes : newStepValue,
      no: result.no ? result.no : newStepValue,
    };
  }

  private static buildForm(formData: RemapFrom, editFlows: boolean) {
    return new FormGroup({
      name: new FormControl({
        value: formData.name,
        disabled: !editFlows,
      }, required('Name')),
      description: new FormControl({
        value: formData.description,
        disabled: !editFlows,
      }, required('Description')),
      remapValues: this.remapValuesForm(formData.remapValues, editFlows),
      valueToRemap: new FormControl({
        value: formData.valueToRemap,
        disabled: !editFlows,
      }, required('Value to remap')),
      yes: new FormControl(formData.yes),
      no: new FormControl(formData.no),
    });
  }

  private static remapValues(values: {}): RemapValues[] {

    if (!values) {
      return [{
        key: '',
        value: '',
      }];
    }

    return Object.keys(values).map(key => ({
      key,
      value: values[key],
    }));
  }


  private static remapValuesForm(values: RemapValues[], editFlows: boolean): FormArray {

    const remap = new FormArray([]);

    for (const value of values) {
      remap.push(
        this.remapValueTemplate(value, editFlows),
      );
    }

    return remap;
  }

  public static remapValueTemplate(remapValue: RemapValues, editFlows: boolean): FormGroup {
    return new FormGroup({
      key: new FormControl({
        value: remapValue?.key ? remapValue?.key : '',
        disabled: !editFlows,
      }, required('Key')),
      value: new FormControl({
        value: remapValue?.value ? remapValue?.value : '',
        disabled: !editFlows,
      }, required('value')),
    });
  }

  get nodeData(): {} {
    return {
      action: this.action,
      'type': 'action',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }

  setNodeData(formData: RemapFrom) {
    const { name, description, yes, no, remapValues, valueToRemap } = formData;

    const remapValue = remapValues
      .map(remap => ({ [remap.key]: remap.value }))
      .reduce((previousValue, currentValue) => ({ ...previousValue, ...currentValue }), {});

    const actionParams = {
      remapValues: remapValue,
      valueToRemap,
    };

    const result = {
      yes,
      no,
    };

    this.action = {
      ...this.action,
      name,
      description,
      actionParams,
      result,
    };
  }
}
